import { ApiErrorCatalog, ResolveApiErrorProps } from '../core/api-error';
import { Failure } from '../core/failure';

export enum BulkRepositoryFailureTypes {
  failToComunicateWithTheServer,
  rejectedByServer,
}

export class BulkRepositoryFailure extends Failure<BulkRepositoryFailureTypes, void> {
  private constructor(errorMessage: string, errorType: BulkRepositoryFailureTypes) {
    super(errorMessage, errorType, undefined);
  }

  public static fromApiError(props: ResolveApiErrorProps) {
    return new BulkRepositoryFailure(
      ApiErrorCatalog.resolveMessage(props),
      BulkRepositoryFailureTypes.failToComunicateWithTheServer
    );
  }

  public static failToComunicateWithTheServer() {
    return new BulkRepositoryFailure(
      'Falha ao enfileirar o disparo',
      BulkRepositoryFailureTypes.failToComunicateWithTheServer
    );
  }

  public static rejectedByServer(message: string) {
    return new BulkRepositoryFailure(message, BulkRepositoryFailureTypes.rejectedByServer);
  }
}
